<template>
  <ais-hits :transform-items="transformItems">
    <template #default="{ items }">
      <ais-state-results>
        <template #default="{ state: { query }, status, nbHits }">
          <div
            v-if="status === 'loading' || status === 'stalled'"
            class="flex justify-center items-center"
          >
            <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
          </div>
          <p
            class="text-center md:text-left text-chrome text-14 font-normal mb-4 lg:mb-m"
            v-show="!(status === 'loading' || status === 'stalled')"
          >
            <span v-if="query"> Companies near {{ query }} </span>
          </p>
          <div class="grid gap-8 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
            <a
              v-for="item in items"
              :key="item.id"
              :href="`/companies/${item.slug}?tab=job&ss=1&pl=${query}`"
            >
              <div
                class="listing-card border-2 border-solid border-transparent max-w-xl"
              >
                <div class="p-6 company-card flex items-center gap-4">
                  <img
                    class="flex object-contain w-16 h-16 rounded-md border border-solid border-chrome-lightest"
                    :src="item.thumbnail"
                    :alt="`${item.name} Logo`"
                    :title="`${item.name} Logo`"
                  />
                  <div class="">
                    <p
                      class="text-lg text-primary-darker font-medium mb-10px company-name"
                    >
                      {{ item.name }}
                    </p>
                    <div class="text-sm text-onyx-lightest font-semibold flex">
                      <vs-icon
                        class="text-lg"
                        icon="icon-briefcase"
                        icon-pack="feather"
                      ></vs-icon>
                      <p class="text-14 ml-8px" v-if="item.jobs">
                        {{ item.jobs_count }} open jobs
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div v-if="nbHits > companiesPerPage" class="flex items-center justify-center mt-40px">
            <div class="flex items-center pagination">
              <div
                class="vs-row flex-1"
                style="
                  justify-content: space-between;
                  display: flex;
                  width: 100%;
                "
              >
                <div
                  class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6"
                  style="
                    justify-content: flex-start;
                    display: flex;
                    align-items: center;
                    margin-left: 0%;
                    width: 100%;
                  "
                ></div>
                <div
                  class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6"
                  style="
                    justify-content: flex-end;
                    display: flex;
                    align-items: center;
                    margin-left: 0%;
                    width: 100%;
                  "
                >
                  <div class="con-vs-pagination vs-pagination-primary">
                    <ais-pagination
                      :show-first="false"
                      :show-last="false"
                      :show-previous="false"
                      :show-next="false"
                      :class-names="{
                        'ais-Pagination-list': 'vs-pagination--ul',
                        'ais-Pagination-item':
                          'item-pagination vs-pagination--li text-lg rounded-full w-10 h-10',
                        'ais-Pagination-item--selected':
                          'is-current !text-white bg-primary',
                        'ais-Pagination-item--disabled': 'disabled',
                        'ais-Pagination-link': '!text-dark-charcoal',
                      }"
                    >
                      <template
                        #default="{
                          currentRefinement,
                          nbPages,
                          nbHits,
                          pages,
                          isFirstPage,
                          isLastPage,
                          refine,
                        }"
                      >
                        <nav class="vs-pagination--nav">
                          <button
                            @click="refine(currentRefinement - 1)"
                            :disabled="isFirstPage"
                            :class="{ disabled: isFirstPage }"
                            class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-chevron-left null"
                            ></i>
                          </button>
                          <ul class="vs-pagination--ul">
                            <li
                              class="item-pagination vs-pagination--li"
                              :class="{
                                'is-current bg-primary':
                                  currentRefinement === pageNumber -1,
                              }"
                              @click="refine(pageNumber -1)"
                              :disabled="currentRefinement === pageNumber -1"
                              v-for="pageNumber in getTotalPage(nbHits)"
                              :key="pageNumber"
                            >
                              <span
                                v-if="
                                  (status === 'loading' ||
                                    status === 'stalled') &&
                                  currentRefinement === pageNumber -1
                                "
                                class="flex justify-center items-center"
                              >
                                <i
                                  class="fa fa-spinner fa-spin fa-1x fa-fw"
                                ></i>
                              </span>
                              <span v-else>{{ pageNumber}}</span>
                            </li>
                          </ul>
                          <button
                            @click="refine(currentRefinement + 1)"
                            :disabled="isLastPage"
                            :class="{ disabled: isLastPage }"
                            class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-chevron-right null"
                            ></i>
                          </button>
                        </nav>
                      </template>
                    </ais-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </ais-state-results>
    </template>
  </ais-hits>
</template>

<script>
import { AisHits, AisPagination } from 'vue-instantsearch';

export default {
  name: 'CompanyHits',
  data() {
    return {
      companiesPerPage: 24,
      params: JSON.parse(this.paramProp),
    }
  },
  components: {
    AisHits,
    AisPagination,
  },
  props: {
    jobsCount: {
      type: Object,
      default: () => {},
    },
    paramProp: {
      default: undefined,
    },
  },
  methods: {
    getTotalPage(totalItems) {
      return Math.ceil(totalItems / this.companiesPerPage);
    },
    transformItems(items) {
      items.forEach(item => {
        item.jobs_count = this.jobsCount?.[item.id] ?? item.jobs.length;
      });

      if (this.params['company_sortable_order']) {
        const sortableFields = this.params['company_sortable_order'];
        items.sort((a, b) => {
          for (const field of sortableFields) {
            if (b[field] !== a[field]) {
              return b[field] - a[field];
            }
          }
          return 0;
        });
      } else {
        items.sort((a, b) => b.jobs_count - a.jobs_count);
      }

      window.scrollTo(0, 0);

      return items;
    },
  },
};
</script>
